const DEEP_DIVE_QUESTIONS = [
  'למה זה קרה?',
  'מה הסיבה האמיתית מאחורי זה?',
  'מה הייתה ההנחה הבסיסית?',
] as const;

export const debriefV2HeTranslations = {
  gather: {
    pageTitle: 'סקירת עובדות שנאספו',
    pageSubtitle:
      'בנינו את ציר הזמן. שכללו את העובדות יחד עם הצוות לפני ניסוח התובנות.',
    stageLabels: {
      goalAndLeadDefinition: '1. הגדרת מטרה ואחראי',
      teamAssembly: '2. הרכבת צוות',
      planning: '3. תכנון',
      execution: '4. ביצוע',
      monitoringAndControl: '5. ניטור ובקרה',
      completionAndApproval: '6. סיום ואישור',
    },
    emptyStage: {
      title: 'לא נמצאו עובדות באופן אוטומטי',
      subtitle: 'לא איתרנו עובדות עבור שלב זה.',
      addFactManually: '+ הוספת עובדה ידנית',
    },
    factRow: {
      viewSource: 'צפו במקור',
      edit: 'עריכה',
      source: {
        jira: 'Jira',
        sharepoint: 'SharePoint',
        confluence: 'Confluence',
      },
    },
    addFact: '+ הוספת עובדה',
    continueButton: 'המשך',
    factDialog: {
      breadcrumbRoot: 'עובדה',
      breadcrumbNew: 'חדש',
      breadcrumbEdit: 'עריכה',
      titleLabel: 'כותרת',
      titlePlaceholder: 'תנו לעובדה כותרת קצרה',
      descriptionLabel: 'תיאור',
      descriptionPlaceholder: 'תארו מה קרה - שמרו על תיאור עובדתי וקצר.',
      dateLabel: 'תאריך',
      cancel: 'ביטול',
      create: 'יצירה',
      save: 'שמירה',
    },
  },
  matchPoints: {
    pageTitle: 'היכן נקבעה התוצאה?',
    pageSubtitle: 'בחרו עד 3 שלבים בתהליך. נצלול לפרטים של כל אחד מהם בהמשך.',
    pickButton: 'בחירה',
    pickedLabel: 'נבחר',
    selectionFooter: {
      hint: 'בחרו עד 3',
      counted: (count: number) => `${count} נבחרו`,
      continue: 'המשך',
    },
  },
  deepDive: {
    factPickPrompt: (stageLabel: string) =>
      `בהסתכלות על ${stageLabel} - איזו עובדה בולטת לכם במיוחד?`,
    question: (index: number) => DEEP_DIVE_QUESTIONS[index] ?? '',
    lessonsPrompt: (stageLabel: string) =>
      `הבנתי - איזה לקח אפשר לקחת מ${stageLabel}?`,
    lessonsFollowUp: 'הבנתי. עוד משהו, או ללחוץ סיום?',
    inputPlaceholderAnswer: 'הקלידו את התשובה שלכם…',
    inputPlaceholderLesson: 'הקלידו לקח - שלחו להוספה, או סיום…',
    send: 'שליחה',
    done: 'סיום',
    pickFactHint: 'בחרו עובדה למעלה כדי להתחיל.',
    matchPointPosition: (current: number, total: number) =>
      `נקודת התאמה ${current} מתוך ${total}`,
  },
  lessons: {
    pageTitle: 'לקחים',
    leaderPill: 'מוביל',
    factInFocusLabel: 'איזו עובדה נדונה?',
    questions: DEEP_DIVE_QUESTIONS,
    lessonsHeading: 'לקחים',
    lessonsCaptured: (count: number) => `${count} נאספו`,
    lessonsEmpty: 'אין עדיין לקחים - הוסיפו את הראשון.',
    addLesson: 'הוספת לקח',
    lessonPlaceholder: 'הקלידו לקח...',
    deleteLessonAria: 'מחיקת לקח',
    cancelLessonAria: 'ביטול לקח',
    waitingForParticipant: 'ממתין למשתתף...',
    outcomeAchieved: 'תוצאה הושגה',
    outcomeNotAchieved: 'תוצאה לא הושגה',
    participantsCount: (count: number) => `משתתפים (${count})`,
    finishDebrief: 'סיום תחקיר',
    manualFactLabel: 'עובדה ידנית',
  },
} as const;
